import { Routes } from '@angular/router';
import { LayoutPage } from './features/layout/layout.page';
import { hasSessionGuard } from './core/guards/has-session.guard';
import { hasActivityGuard } from './core/guards/has-activities.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    canActivate: [hasSessionGuard, hasActivityGuard],
    component: LayoutPage,
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'customers',
        loadChildren: () =>
          import('./features/customers/customers.routes').then(
            (m) => m.CUSTOMERS_ROUTES
          ),
      },
      {
        path: 'customer',
        loadChildren: () =>
          import('./features/customer/customer.routes').then(
            (m) => m.CUSTOMER_ROUTES
          ),
      },
      {
        path: 'pet',
        loadChildren: () =>
          import('./features/pet/pet.routes').then((m) => m.PET_ROUTES),
      },
      {
        path: 'operators',
        loadChildren: () =>
          import('./features/operators/operators.routes').then(
            (m) => m.OPERATORS_ROUTES
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then(
            (m) => m.SETTINGS_ROUTES
          ),
      },
      {
        path: 'materials',
        loadChildren: () =>
          import('./features/materials/materials.routes').then(
            (m) => m.MATERIALS_ROUTES
          ),
      },
      {
        path: 'expenses',
        loadChildren: () =>
          import('./features/expenses/expenses.routes').then(
            (m) => m.EXPENSES_ROUTES
          ),
      },
      {
        path: 'balance',
        loadChildren: () =>
          import('./features/balance/balance.routes').then(
            (m) => m.BALANCE_ROUTES
          ),
      },
      {
        path: 'agenda',
        loadChildren: () =>
          import('./features/agenda/agenda.routes').then(
            (m) => m.AGENDA_ROUTES
          ),
      },
      {
        path: 'appointment',
        loadChildren: () =>
          import('./features/appointment/appointment.routes').then(
            (m) => m.APPOINTMENT_ROUTES
          ),
      },
      {
        path: 'pet-service',
        loadChildren: () =>
          import('./features/pet-service/pet-service.routes').then(
            (m) => m.PET_SERVICE_ROUTES
          ),
      },
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./features/account/account.routes').then((m) => m.ACCOUNT_ROUTES),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/register/register.page').then((m) => m.RegisterPage),
  },
];
